import React from 'react';

function Home({ setPage }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', background: '#f7f9fa', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: 40, margin: 40
    }}>
      <img
        src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
        alt="Logistics"
        style={{ width: 300, borderRadius: 12, marginBottom: 32, boxShadow: '0 2px 12px rgba(0,0,0,0.10)' }}
      />
      <h1 style={{ fontSize: 36, marginBottom: 16, color: '#1a355e' }}>Welcome to Swift Logistics ERP</h1>
      <p style={{ fontSize: 18, color: '#444', marginBottom: 32, maxWidth: 500, textAlign: 'center' }}>
        Manage your customs and freight forwarding operations efficiently. Use the modules below to get started.
      </p>
      <div>
        <button
          onClick={() => setPage('customs')}
          style={{
            padding: '12px 32px',
            fontSize: 18,
            marginRight: 20,
            background: '#1a355e',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(26,53,94,0.10)'
          }}
        >
          Go to Customs
        </button>
        <button
          onClick={() => setPage('freight')}
          style={{
            padding: '12px 32px',
            fontSize: 18,
            background: '#2e8b57',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(46,139,87,0.10)'
          }}
        >
          Go to Freight Forwarding
        </button>
      </div>
    </div>
  );
}

export default Home; 